import { render, staticRenderFns } from "./addPara.vue?vue&type=template&id=315db5e5&scoped=true"
import script from "./addPara.vue?vue&type=script&lang=js"
export * from "./addPara.vue?vue&type=script&lang=js"
import style0 from "./addPara.vue?vue&type=style&index=0&id=315db5e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315db5e5",
  null
  
)

export default component.exports